export var CloseButtonVariantType;
(function (CloseButtonVariantType) {
    CloseButtonVariantType["PRIMARY"] = "PRIMARY";
    CloseButtonVariantType["PRIMARY_ON_SURFACE"] = "PRIMARY_ON_SURFACE";
    CloseButtonVariantType["SECONDARY"] = "SECONDARY";
    CloseButtonVariantType["SECONDARY_ON_SURFACE"] = "SECONDARY_ON_SURFACE";
    CloseButtonVariantType["SECONDARY_FLOATING"] = "SECONDARY_FLOATING";
    CloseButtonVariantType["CUSTOM"] = "CUSTOM";
    CloseButtonVariantType["MAIN_SECTION"] = "MAIN_SECTION";
})(CloseButtonVariantType || (CloseButtonVariantType = {}));
export var CloseButtonSizeType;
(function (CloseButtonSizeType) {
    CloseButtonSizeType["SMALL_PRIMARY"] = "SMALL_PRIMARY";
    CloseButtonSizeType["SMALL_SECONDARY"] = "SMALL_SECONDARY";
    CloseButtonSizeType["LARGE_PRIMARY"] = "LARGE_PRIMARY";
    CloseButtonSizeType["LARGE_SECONDARY"] = "LARGE_SECONDARY";
})(CloseButtonSizeType || (CloseButtonSizeType = {}));
//# sourceMappingURL=closeButton.js.map